<template>
  <v-layout row wrap >
    <!-- Dialog -->
    <v-dialog v-model="json_data.status" fullscreen transition="dialog-bottom-transition" :overlay="false">
      <v-card style="background-color:#EEEEEE;">
        <v-toolbar dark color="primary">
          
            <v-btn icon dark @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
          
          <v-toolbar-title>{{ json_data.save_type == 'create' ? $t('menu.ReSignCreate') : $t('menu.ReSignEdit') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text >
          <v-container background fluid >
            <v-layout row wrap pa-3 style="background-color:#fff; margin-top:5px; border-radius:5px;">
              <v-flex xs12>
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <v-flex md6 sm6 xs12 pa-1 v-if="json_data.save_type == 'create'">
                      <v-text-field :label="$t('doc_no')" append-icon="fas fa-plus-circle" hide-details
                        v-model="form_model.doc_no" :rules="form_rules.doc_no" required @click:append="doNewGuid" />
                    </v-flex>
                     <v-flex md6 sm6 xs12 pa-1 v-if="json_data.save_type != 'create'">
                      <v-text-field :label="$t('doc_no')" hide-details readonly
                        v-model="form_model.doc_no" :rules="form_rules.doc_no" required />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-autocomplete hide-details :loading="loading" v-model="form_model.emp_code" :items="Employee_List"
                        item-text="name" item-value="code" :label="$t('employee_code')" allow-overflow append-icon="search"
                        clearable required :rules="form_rules.emp_code" />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field :label="$t('request_date')" hide-details v-model="form_model.request_date" required
                        :rules="form_rules.request_date" type="date" />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field :label="$t('effective_date')" hide-details v-model="form_model.effective_date"
                        required :rules="form_rules.effective_date" type="date" />
                    </v-flex>
                    <v-flex md12 sm12 xs12 pa-1>
                      <v-textarea :label="$t('remark')" v-model="form_model.remark" hide-details />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right pa-3>
              <v-btn color="success" @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
                <v-icon>save</v-icon>
                <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
  /* eslint-disable */
  import {
    mapState,
    mapActions
  } from "vuex";
  import Utils from "@/utils/";
  import DocumentService from "@/services/DocumentService";

  export default {
    props: {
      json_data: Object
    },
    watch: {
      json_data(val) {
        this.getEmployee("newData");
        this.doNewGuid();
        if (val.data != null) {
          this.form_model = val.data;
        } else {
          this.$refs.form.resetValidation();
        }
      }
    },
    data: () => ({
      form_valid: false,
      form_model: {
        emp_code: "",
        doc_no: "",
        request_date: new Date().toISOString().slice(0, 10),
        effective_date: new Date().toISOString().slice(0, 10),
        remark: "",
        creator_code: localStorage._usercode,
        company_id : localStorage._company_guid,
      },
      form_rules: {
        emp_code: [v => !!v || "do not empty."],
        doc_no: [v => !!v || "do not empty."],
        request_date: [v => !!v || "do not empty."],
        effective_date: [v => !!v || "do not empty."]
      },
      snack_model: {
        status: "",
        msg: "",
        type: ""
      }
    }),
    created: function () {
      this.getEmployee("refesh");
      this.doNewGuid();
    },
    computed: {
      ...mapState("filter", ["loading", "Employee_List"])
    },
    methods: {
      ...mapActions("filter", ["getEmployee"]),
      closeDialog() {
        this.clearForm();
        this.$emit("close-dialog");
      },
      doNewGuid() {
        this.form_model.doc_no = Utils.newGuid("RS"+ localStorage._company_guid.substr(0, 6)).toUpperCase();
      },
      clearForm() {
        this.form_model = {
          emp_code: "",
          doc_no: "",
          request_date: new Date().toISOString().slice(0, 10),
          effective_date: new Date().toISOString().slice(0, 10),
          remark: "",
          creator_code: localStorage._usercode
        };
      },
      showSnackBar(msg, type) {
        this.snack_model.msg = msg;
        this.snack_model.type = type;
        this.snack_model.status = true;
      },
      // getDetail(param) {
      //   DocumentService.getResignByCode(param)
      //     .then(res => {
      //       this.showLoading = false;
      //       this.form_model = res.data;
      //     })
      //     .catch(err => {
      //       console.log(err);
      //     });
      // },
      onSave() {
        if (this.form_valid) {
          this.form_model.company_id = localStorage._company_guid;
          DocumentService.createResing(this.form_model)
            .then(res => {
              this.showSnackBar('save success', 'success');
              this.closeDialog();
            })
            .catch(err => {
              this.showSnackBar(err.response.data, 'error');
            });
        } else {
          this.$refs.form.validate();
        }
      },
      onUpdate() {
        if (this.form_valid) {
          this.form_model.company_id = localStorage._company_guid;
          DocumentService.updateResing(this.form_model)
            .then(res => {
              this.showSnackBar('update success', 'success');
              this.closeDialog();
            })
            .catch(err => {
              this.showSnackBar(err.response.data, 'error');
            });
        } else {
          this.$refs.form.validate();
        }
      }
    }
  };
</script>
<style >
 .v-card__text{
    padding:0px;
  }
</style>